<template>
  <div class="card-row card-row-show">
    <div class="card-row-col card-col w15">
      <Checkbox @change="$emit('selectWallet', wallet.id, value)"
        :disabled="getDisabled"
        v-model="value"/>
    </div>
    <div class="card-row-col card-col wp10">
      {{wallet.create_date | moment('DD MMM YYYY') }}
    </div>
    <div class="card-row-col card-col wp15">
      {{wallet.order_no}}
    </div>
    <div class="card-row-col card-col wp10">
      {{wallet.source}}
    </div>
    <div class="card-row-col card-col wp10">
      {{wallet.destination}}
    </div>
    <div class="card-row-col card-col wp10">
      {{type[wallet.type]}}
    </div>
    <div class="card-row-col card-col wp15">
      {{wallet.amount}}
    </div>
    <div class="card-row-col card-col wp10">
      {{status[wallet.status]}}
    </div>
  </div>
</template>

<script>
import WalletConstants from '@/constants/wallet';

const type = WalletConstants.WalletTypeForExcel;
const status = WalletConstants.StatusType;

export default {
  props: ['wallet', 'value'],
  data() {
    return {
      type,
      status,
    };
  },
  computed: {
    getDisabled() {
      const statusList = [1, 4];
      return !statusList.includes(this.wallet.status);
    },
  },
};
</script>

